<modal-layout-right (close)="close()"
                    sl-minibasket-container
                    cy-minibasketView
                    #contentContainer>
    <ng-container ngProjectAs="[modalTitle]">
        <div class="flex flex-justify-between flex-bottom">
            <h5>
                <span class="h3 p-r-3">{{'Shopping Bag' | translate}}</span>
                @if (basket.qty) {
                <span class="p1 col-12"
                      [ngPlural]="basket.qty">
                    <ng-template ngPluralCase="=1">{{ basket.qty }} <span>{{'Item' | translate}}</span></ng-template>
                    <ng-template ngPluralCase="other">{{ basket.qty }} <span>{{'Items' |
                            translate}}</span></ng-template>
                </span>
                }
            </h5>
            <flush-basket-button class="m-r-15"
                                 *ifTradeStore></flush-basket-button>
        </div>
    </ng-container>

    <ng-container ngProjectAs="[modalBody]">

        @switch (!!basket.qty) {
        <!-- empty -->
        @case (false) {
        <p class="p-a-5 center p2"
           cy-basketEmpty>
            {{ 'Your bag is empty' | translate }}
        </p>
        }
        @default {
        <!-- free delivery notice -->
        <ng-container *ifStore="'uk'">
            @if (basket.freeShippingRules && basket.freeShippingRules.length > 0) {
            <div class="bg-col-51 col-6 p-a-3 center p2">
                @for (rule of basket.freeShippingRules; track $index) {
                @if (rule.value > (basket.data.totals?.subtotal || 0)) {
                {{ 'You are' | translate }}&nbsp;
                <price class="price"
                       [value]="rule.value - (basket.data.totals?.subtotal || 0)">
                </price>
                &nbsp;{{ 'away from Free %' | translate : rule.name }}
                }
                @if (rule.value <= (basket.data.totals?.subtotal
                   ||
                   0))
                   {
                   {{ 'You have Free %'
                   |
                   translate
                   :
                   rule.name
                   }}
                   }
                   }
                   </div>
                    }
        </ng-container>
        <!-- product list -->
        <div class="p-r-5 p-l-5"
             #list>
            <ul cy-minibasketList>
                @for (item of basketItems | orderBy : ['data.added_at'] : ['desc']; track itemTrackFn($index, item);
                let isLast = $last) {
                <li cy-minibasketItem>
                    <minibasket-item class="w-12"
                                     [ngClass]="{ 'b-b b-col-42': !isLast }"
                                     [item]="item"></minibasket-item>
                </li>
                }
            </ul>
        </div>
        }
        }


        @if (content?.klevu_recommendations_id) {
        <basket-related-products class="block m-b-5"
                                 [limit]="10"
                                 [source]="productsIds"
                                 [options]="relatedProductsOptions">
        </basket-related-products>
        }

        <icms-outlet-block [name]="'Minibasket ac'"
                           [variant]="'minibasket-ac'"
                           [allowOnly]=" ['advanced-commerce']"></icms-outlet-block>

    </ng-container>

    <ng-container ngProjectAs="[modalFooter]">
        @if (!!basket.qty) {
        <div class="p-r-5 p-l-5"
             cy-minibasketTotal>
            <basket-view-totals class="block"></basket-view-totals>
            <!-- go to checkout -->
            <div class="c-12-set m-r-0 p-l-1 m-t p-t-2">
                <a routerLink="/basket"
                   sl-minibasket-button="basket"
                   cy-basketMinibasket
                   class="w-12 p-r-0 p-l-0 button">
                    <span class="p1 col-w">{{'Checkout securely' | translate}}</span>
                </a>
            </div>
            <payments-methods-logos-block class="p-b-8 m-l-1"></payments-methods-logos-block>
            <!-- stock info -->
            @if (!isSalable) {
            <p class="m-t-1 col-2 p2 center m-b-3">{{'Some products in your bag are out of stock' | translate}}</p>
            }
            <!-- content block -->
            <!-- <minibasket-content-block></minibasket-content-block> -->
        </div>
        }
    </ng-container>
</modal-layout-right>